"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _withCache = _interopRequireDefault(require("./withCache"));

var linkCache = {};

var _default = (0, _withCache.default)(linkCache);

exports.default = _default;
module.exports = exports.default;